// extracted by mini-css-extract-plugin
export default {"scrollToTop":"ScrollToTop_scrollToTop__WRzqu","visible":"ScrollToTop_visible__ayEIH","floatBtn":"ScrollToTop_floatBtn__8ldbw","gradientRotate":"ScrollToTop_gradientRotate__7Io56"};